import {Component, Input, OnInit} from "@angular/core";
import {first, takeUntil} from "rxjs/operators";
import modes from "./modes.json";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../store";
import {DbStoreState} from "../../../../store";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import {UserSubscription} from "../../../../user/user-subscription";
import {Subject} from "rxjs";
import {IOMode, WebsiteService} from "../../../website.service";
import {NotifierComponent} from "../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../shared/components/notifier/notification-type";
import {TextUtils} from "../../../../shared/utils/text-utils";
import {TypeUtils} from "../../../../shared/utils/type-utils";
import {DbTextPipe} from "../../../../shared/pipes/db-text.pipe";


interface Mode {
  id: IOMode;
  key: number;
  title: string;
  desc: string;
}

@Component({
    selector: 'db-optimization-modes',
    templateUrl: './image-optimization-modes.component.html',
    styleUrls: ['./image-optimization-modes.component.scss'],
    standalone: false
})
export class ImageOptimizationModesComponent implements OnInit {

  public settingsOptions: any[] = modes;
  public loadingApply: boolean;
  public ioMode: IOMode;
  public initialIOMode: IOMode = 'lossy40';
  public testModeEnabled: boolean;
  public ioModeLoading: boolean = true;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  @Input() websiteId: number;
  @Input() userSubscription: UserSubscription;

  constructor(
    private _store: Store<DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _websiteService: WebsiteService,
    private _dbText: DbTextPipe,
  ) {
  }

  ngOnInit() {
    this._getIOModeLevel();
  }

  public selectMode(mode: IOMode): void {
    this.ioMode = mode;
    this.apply();
  }


  public apply(): void {
    this._applyMode(this.ioMode);
  }

  private _applyMode(mode: IOMode): void {
    this._websiteService.setIOMode(this.websiteId, mode)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadWebsites());
          NotifierComponent.notify(new Notification(response.message, NotificationType.SUCCESS));
        } else {
          this.ioMode = this.initialIOMode;
          NotifierComponent.notify(new Notification(TextUtils.getText('text_somethingWentWrongDot'), NotificationType.DANGER));
        }
        this.loadingApply = false;
      });

  }

  private _getIOModeLevel(): void {
    this._websiteService.getIOMode(this.websiteId)
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(response => {
        if (!TypeUtils.isNull(response)) {
          this.ioMode = response.data.level;
          this.initialIOMode = response.data.level;
          this.ioModeLoading = false;
        }
      });
  }

}
